module.exports = __webpack_public_path__ + "static/media/job.f411785e.png";